export default class WbxYouTubeFallback {
    constructor(props) {
        this.listener = function (e) {
            e.preventDefault();
            return false;
        };
        this.interval = setInterval(() => {
            if (window.CookieFirst) {
                this.init();
                clearInterval(this.interval);
            }
        }, 100);
    }

    init() {
        let elements = document.querySelectorAll("[data-youtube-cookiefirst]");
        if (elements) {
            elements.forEach((v, k) => {
                if (v.nodeName === "A") {
                    v.removeAttribute('data-lightgallery-item');

                    let newNode = v.cloneNode(true);
                    newNode.addEventListener("click", this.listener);
                    newNode.dataset.href = newNode.href;
                    newNode.href = "";
                    v.parentElement.appendChild(newNode);
                    v.remove();
                }
            });

            elements = document.querySelectorAll("[data-youtube-cookiefirst]");

            let cookieTool = window.CookieFirst;
            elements.forEach((v, k) => {
                if (cookieTool && cookieTool.consent && cookieTool.consent.advertising) {
                    this.embedVideos(elements);
                } else {
                    v.parentElement.querySelector('.video-cookie-fallback span').addEventListener('click', (e) => {
                        e.preventDefault();
                        if (window.CookieFirst) {
                            window.CookieFirst.acceptCategory("advertising");
                        }
                        this.embedVideos(elements);
                        return false;
                    });
                }
            });
        }
    }

    embedVideos(videos) {
        videos.forEach((v, k) => {
            if (v.nodeName === "A") {
                v.removeEventListener("click", this.listener);
                v.href = v.dataset.href;
                v.setAttribute('data-lightgallery-item', 'image');
            } else if (v.nodeName === "IFRAME") {
                v.src = v.dataset.url;
            }
            v.parentElement.classList.add('video-loaded');
        });

        window.dispatchEvent(new CustomEvent("refresh-aos"))
        window.dispatchEvent(new CustomEvent("init-light-gallery"))
    }
}
